import React from "react";
import JobPostListItem from "./JobPostListItem";
import { Segment } from "semantic-ui-react";
import { SEMANTIC_DIV } from "../../../css/styles";

export default function JobPostsList({
  jobs,
  heading,
  noJobsMessage,
  editable = true,
  deletable = false,
  preview = false,
  repost = false,
  stats = false,
  applicants = false,
  handleSetApplicantsView = () => {},
  handleSetStatsView = () => {},
  type,
  isAdmin = false,
  loading = false,
  mainButton = "",
  isShowMenu = true,
}) {
  return (
    <div className="manage-job-list">
      <Segment basic style={{ ...SEMANTIC_DIV }} disabled={loading}>
        <div className="body-bold-text">{heading}</div>
        <div className="manage-job-list-container">
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <JobPostListItem
                job={job}
                key={job.id}
                editable={editable}
                deletable={deletable}
                repost={repost}
                stats={stats}
                applicants={applicants}
                handleSetApplicantsView={handleSetApplicantsView}
                handleSetStatsView={handleSetStatsView}
                type={type}
                isAdmin={isAdmin}
                preview={preview}
                mainButton={mainButton}
                isShowMenu={isShowMenu}
              />
            ))
          ) : (
            <span className="manage-item-list-no-item">{noJobsMessage}</span>
          )}
        </div>
      </Segment>
    </div>
  );
}
